import React, { useState } from 'react'
import {
  // NavLink, 
  Link, useNavigate
} from 'react-router-dom'
import './navBar.css'
import { FaCrown } from 'react-icons/fa';
import { GiHelp } from 'react-icons/gi';
// import { navLinks } from './NavLinksData'
import { FaAngleDown, FaEnvelope, FaLock, FaUser, FaPowerOff, FaRegSun, FaFilter, FaExclamationCircle } from 'react-icons/fa'
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, notification } from 'antd';
// import SubNav from './SubNav'
import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux';
import { logoutUser } from '../../Redux/features/User/userSlice';
import { FcExpired } from 'react-icons/fc';
import Logo from '../../images/transLogoWhite.svg'
import { Image } from 'react-bootstrap'
import key from '../../key';
import { Badge } from 'antd';

const NavBar = () => {
  const [showProfile, setShowProfile] = useState(false);
  // const [activeMenu, setActiveMenu] = useState('');
  //eslint-disable-next-line
  const [cookies, setCookie, removeCookie] = useCookies('x-auth-token');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);


  const toggleProfile = () => {
    setShowProfile(!showProfile);
  }

  const profileStyle = showProfile ? "profile-dropdown d-flex" : "profile-dropdown d-none";

  const logout = () => {
    notification.success({
      message: 'You have been logged out successfully',
    });
    removeCookie('x-auth-token');
    cookies['x-auth-token'] = null;
    dispatch(logoutUser());
    navigate('/landing');
  };
  const premiums = [
    {
      key: '0',
      label: 'View Other Plans',
      onClick: () => navigate('/pricing-table')
    },
    {
      key: '1',
      icon: <FaCrown size={30} />,
      label: `${user.userStatus.membership.membershipType}`,
    }, {
      key: '2',
      label: `Expiry Date: ${user.userStatus.membership.expiryDate}`,
      icon: <FcExpired size={30} />,
    },
    {
      key: '3',
      danger: true,
      label: `Remaining Likes: ${user.userStatus.membershipDetails.likes}`
    },
    {
      key: '4',
      danger: true,
      label: `Remaining Contact Views: ${user.userStatus.membershipDetails.viewContacts}`,
    },
  ]
  const help = [
    {
      key: '1',
      icon: <GiHelp size={20} />,
      label: `Help Desk`,
      onClick: () => navigate('/help-desk')
    }
  ]
  const myShadi = [
    {
      key: '1',
      label: 'Dashboard',
      onClick: () => navigate('/dashboard')
    },
    {
      key: '2',
      label: 'My Profile',
      onClick: () => navigate('/myprofile')
    },
    {
      key: '3',
      label: 'My Photos',
      onClick: () => navigate('/myphotos')
    },
    {
      key: '4',
      label: 'Partner Preferences',
      onClick: () => navigate('/partnerpreferences')
    },
    {
      key: '5',
      label: 'Settings',
      onClick: () => navigate('/settings')
    },
    {
      key: '6',
      label: 'Edit profile',
      onClick: () => navigate('/edit-personal-profile')
    }
  ]
  const matches = [
    {
      key: '1',
      label: 'New Matches',
      onClick: () => navigate('/newmatches')
    },
    {
      key: '2',
      label: 'Today\'s Matches',
      onClick: () => navigate('/todaysmatches')
    },
    {
      key: '3',
      label: 'Near Me',
      onClick: () => navigate('/nearme')
    },
    {
      key: '4',
      label: 'Recently Viewed',
      onClick: () => navigate('/recently-viewed/recent')
    },
  ]

  const search = [
    {
      key: '1',
      label: 'Basic Search',
      onClick: () => navigate('/basicsearch')
    },
    {
      key: '2',
      label: 'Search By Profile ID',
      onClick: () => navigate('/basicsearch')
    },
    {
      key: '3',
      label: 'Advanced Search',
      onClick: () => navigate('/advancedsearch')
    },
  ]

  const inbox = [
    {
      key: '1',
      label: 'Received Invitations',
      onClick: () => navigate('/received')
    },
    {
      key: '2',
      label: 'Accepted Invitations',
      onClick: () => navigate('/accepted')
    },
    {
      key: '3',
      label: 'Sent Invitation',
      onClick: () => navigate('/sent')
    },
    {
      key: '4',
      label: 'Deleted Invitations',
      onClick: () => navigate('/deleted')
    },
    {
      key: '5',
      label: 'Chat',
      onClick: () => navigate('/chat')
    },
  ]
  const chatNumber = user.unreadMessages || 0;
  return (
    <nav >
      <h1 className="logo"><Link to='/'>
        <Image src={Logo} width={50} height={50} alt="logo" />
      </Link></h1>
      <div className='menu'>
        <Dropdown
          menu={{
            items: myShadi,
          }}
        >
          <Link className='text-white' onClick={(e) => e.preventDefault()}>
            <Space>
              My Lovodi
              <DownOutlined />
            </Space>
          </Link>
        </Dropdown>

        <Dropdown
          menu={{
            items: matches,
          }}
        >
          <Link className='text-white' onClick={(e) => e.preventDefault()}>
            <Space>
              Matches
              <DownOutlined />
            </Space>
          </Link>
        </Dropdown>
        <Dropdown
          menu={{
            items: search,
          }}
        >
          <Link className='text-white' onClick={(e) => e.preventDefault()}>
            <Space>
              Search
              <DownOutlined />
            </Space>
          </Link>
        </Dropdown>
        <Dropdown
          menu={{
            items: inbox.map(item => {
              if (item.label === 'Chat') {
                return {
                  ...item,
                  label: (
                    <Space>
                      {item.label}
                      {chatNumber > 0 && <Badge count={chatNumber} offset={[10, 0]} />}
                    </Space>
                  ),
                };
              }
              return item;
            }),
          }}
        >
          <Link className='text-white' onClick={(e) => e.preventDefault()}>
            <Space>
              Inbox
              <DownOutlined />
              {chatNumber > 0 && <Badge count={chatNumber} offset={[0, 0]} />}
            </Space>
          </Link>
        </Dropdown>
        {/* <NavLink><button className={`subnavbtn`}>My Lovodi <FaAngleDown /></button></NavLink> */}
        {/* {navLinks.map((link, i) => (
          <SubNav key={i} title={link.name} links={link.subLinks} activeMenu={activeMenu} setActiveMenu={setActiveMenu} />
        ))} */}
      </div>

      <div className='d-flex justify-content-between'>
        <div className='menu-items'>
          {user.userStatus.membership.membershipType === 'Free' || user.userStatus.membership.isExpired ? (
            <Link to='/pricing-table'>
              <Space>
                <FaCrown size={25} /> Upgrade Now
              </Space>
            </Link>
          ) : (
            <Dropdown
              menu={{
                items: premiums,
              }}
            >
              <Link onClick={(e) => e.preventDefault()}>
                <Space>
                  <FaCrown size={25} /> Premium
                  <DownOutlined />
                </Space>
              </Link>
            </Dropdown>
          )}
        </div>
        <div className='bodr'></div>
        <div className='menu-items'>
          <Dropdown
            menu={{
              items: help,
            }}
          >
            <Link>
              <Space>
                Help
                <DownOutlined />
              </Space>
            </Link>
          </Dropdown>
        </div>
      </div>
      <div className='profile-icon'>
        <button onClick={toggleProfile}>
          {
            user?.photos[0] ? (
              <img src={`${key}/images/${user.photos[0].url}`} alt="profile" />
            ) : (
              <img src="https://www.allianceplast.com/wp-content/uploads/no-image-1024x1024.png" alt="profile" />
            )
          }
          <FaAngleDown className='text-white mx-1' />
        </button>
        <div className={profileStyle} >
          <div className='row'>
            <div className='photo-prompt'>
              <FaExclamationCircle className='text-secondary mx-2' />
              More Picture Means More Matches
            </div>
            <Link to="myPhotos" className='btn btn-primary btn-sm w-auto upgrade-btn my-2 fw-bold'>Upload Photo</Link>
          </div>
          <div className='profile-settings'>

            <div className='profile-settings-col'>
              <div className='col'>
                <Link to='/myprofile'><div className='row '><span><FaUser className='text-secondary mx-2' /> My Profile</span></div></Link>
                <Link to='/settings'><div className='row '><span><FaRegSun className='text-secondary mx-2' /> Account Settings</span></div></Link>
                <Link to='/partnerpreferences'><div className='row '><span><FaFilter className='text-secondary mx-2' /> Partner Prefrences</span></div></Link>
              </div>
            </div>
            <div className='profile-settings-col'>
              <div className='col'>
                <Link to='/settings'><div className='row '><span><FaEnvelope className='text-secondary mx-2' /> Email / SMS Alerts</span></div></Link>
                <Link to='/settings'><div className='row '><span><FaLock className='text-secondary mx-2' /> Privacy Options</span></div></Link>
                <Link onClick={logout}><div className='row '><span><FaPowerOff className='text-secondary mx-2' /> Logout</span></div></Link>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='membership-info'>
              Account type: {user.userStatus.membership.membershipType}
            </div>
            {user.userStatus.membership.membershipType === "Free" ? <button className='btn btn-primary btn-sm w-auto upgrade-btn my-2 fw-bold'>Upgrade Now</button>
              : (<div className='membership-info'>
                Expiry Date: {user.userStatus.membership.expiryDate}
              </div>)}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavBar
